import AgencyApi from "@/services/agencyApi";
const agencyApi = new AgencyApi();

const state = {
  agency: {},
  site: {},
  currencyCode: null,
  pageData: {}
};

const mutations = {
  setCurrencyCode(state, currencyCode) {
    state.currencyCode = currencyCode;
  }
};

const getters = {
  getAgency: state => { return state.agency },
  getSite: state => { return state.site },

  getAgencySettings: state => { return state.site ? state.site.settings : {} },
  getAgencyName: state => { return state.site ? state.site.settings.agencyName : {} },
  getAgencyDisplay: state =>  { return state.site ? state.site.display : {} },
  getAgencyMenus: state =>  { return state.site ? state.site.menus : {} },
  getPageContent: state => async page => {
    if (!state.pageData.hasOwnProperty(page)) {
      state.pageData[page] = (await agencyApi.getPageContent(page)).data;
    }

    return state.pageData[page];
  },

  getCurrencyCode: state => {
    if(state.site) {
      if(!state.currencyCode) {
        if (state.site.display && state.site.display.currency) {
          state.currencyCode = state.site.display.currency;
        } else {
          state.currencyCode = 'USD'
        }
      }
      return state.currencyCode
    } else {
      return {}
    }
  }

};

const actions = {

  setAgencyRef : ({state}, {agency}) => {
    state.agency = agency;
  },
  setSiteRef : ({state}, {site}) => {
    state.site = site;
  },

  setCurrencyCode ({commit}, currencyCode) {
    commit('setCurrencyCode', currencyCode);
  }
};

export default {
  state,
  mutations,
  getters,
  actions
}